// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SqsN-","stories":"_11ALQ"};